export type SafeRichTextUrlKind = 'email' | 'external' | 'internal'

export function isEfficientReferralUrl(value: unknown): boolean {
  if (typeof value !== 'string') return false

  try {
    const url = new URL(value)
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      url.hostname === 'efficient.link' &&
      url.pathname.startsWith('/r/')
    )
  } catch {
    return false
  }
}

function isValidMailto(url: URL): boolean {
  if (!url.pathname || url.pathname.includes(' ')) return false

  return url.pathname.split(',').every((recipient) => {
    const atIndex = recipient.indexOf('@')
    return atIndex > 0 && atIndex === recipient.lastIndexOf('@') && atIndex < recipient.length - 1
  })
}

export function classifySafeRichTextUrl(value: unknown): SafeRichTextUrlKind | null {
  if (
    typeof value !== 'string' ||
    value.length === 0 ||
    value !== value.trim() ||
    /\s/.test(value)
  ) {
    return null
  }

  if (value.startsWith('#')) return null
  if (value.startsWith('/')) {
    return value.startsWith('//') || value.startsWith('/\\') ? null : 'internal'
  }

  try {
    const url = new URL(value)
    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return url.hostname ? 'external' : null
    }
    if (url.protocol === 'mailto:') {
      return isValidMailto(url) ? 'email' : null
    }
  } catch {
    return null
  }

  return null
}

export function validateRichTextCustomUrl(value: unknown): true | string {
  return classifySafeRichTextUrl(value)
    ? true
    : 'Custom links must use https://, http://, mailto:, or an internal / path'
}
